// src/activities/cape-vr/cape-vr-views/cape-vr-files/cape-vr-form-files/CAPEVRRatingForm.jsx

import StandardVocalAttributesRating from './StandardVocalAttributesRating';
import PitchLoudnessEvaluation from './PitchLoudnessEvaluation';
import ResonanceNasalityEvaluation from './ResonanceNasalityEvaluation';
import InconsistenciesEvaluation from './InconsistenciesEvaluation';
import InstabilitiesEvaluation from './InstabilitiesEvaluation';
import AdditionalFeaturesEvaluation from './AdditionalFeaturesEvaluation';
import OverallImpression from './OverallImpression';

function CAPEVRRatingForm({ 
  t,
  overallSeverity, setOverallSeverity,
  roughness, setRoughness,
  breathiness, setBreathiness,
  strain, setStrain,
  customVasLabel, setCustomVasLabel,
  customVasValue, setCustomVasValue,
  selectedInstabilities, setSelectedInstabilities,
  instabilitiesValues, setInstabilitiesValues,
  selectedAdditionalFeatures, setSelectedAdditionalFeatures,
  additionalFeaturesValues, setAdditionalFeaturesValues,
  normalPitch, setNormalPitch,
  tooHighPitch, setTooHighPitch,
  tooLowPitch, setTooLowPitch,
  normalLoudness, setNormalLoudness,
  tooLoudLoudness, setTooLoudLoudness,
  tooQuietLoudness, setTooQuietLoudness,
  normalResonance, setNormalResonance,
  frontResonance, setFrontResonance,
  backResonance, setBackResonance,
  normalNasality, setNormalNasality,
  hypernasality, setHypernasality,
  hyponasality, setHyponasality,
  vowelsInconsistency, setVowelsInconsistency,
  sentencesInconsistency, setSentencesInconsistency,
  extemporaneousSpeechInconsistency, setExtemporaneousSpeechInconsistency,
  inconsistencyStatus, setInconsistencyStatus,
  overallImpressionComment, setOverallImpressionComment
}) {
  return (
    <div className="capevr-rating-form">

      <StandardVocalAttributesRating
        overallSeverity={overallSeverity}
        setOverallSeverity={setOverallSeverity}
        roughness={roughness}
        setRoughness={setRoughness}
        breathiness={breathiness}
        setBreathiness={setBreathiness}
        strain={strain}
        setStrain={setStrain}
        customVasLabel={customVasLabel}
        setCustomVasLabel={setCustomVasLabel}
        customVasValue={customVasValue}
        setCustomVasValue={setCustomVasValue}
      />

      <PitchLoudnessEvaluation
        normalPitch={normalPitch}
        setNormalPitch={setNormalPitch}
        tooHighPitch={tooHighPitch}
        setTooHighPitch={setTooHighPitch}
        tooLowPitch={tooLowPitch}
        setTooLowPitch={setTooLowPitch}
        normalLoudness={normalLoudness}
        setNormalLoudness={setNormalLoudness}
        tooLoudLoudness={tooLoudLoudness}
        setTooLoudLoudness={setTooLoudLoudness}
        tooQuietLoudness={tooQuietLoudness}
        setTooQuietLoudness={setTooQuietLoudness}
      />

      <ResonanceNasalityEvaluation
        normalResonance={normalResonance}
        setNormalResonance={setNormalResonance}
        frontResonance={frontResonance}
        setFrontResonance={setFrontResonance}
        backResonance={backResonance}
        setBackResonance={setBackResonance}
        normalNasality={normalNasality}
        setNormalNasality={setNormalNasality}
        hypernasality={hypernasality}
        setHypernasality={setHypernasality}
        hyponasality={hyponasality}
        setHyponasality={setHyponasality}
      />

      <InconsistenciesEvaluation
        vowelsInconsistency={vowelsInconsistency}
        setVowelsInconsistency={setVowelsInconsistency}
        sentencesInconsistency={sentencesInconsistency}
        setSentencesInconsistency={setSentencesInconsistency}
        extemporaneousSpeechInconsistency={extemporaneousSpeechInconsistency}
        setExtemporaneousSpeechInconsistency={setExtemporaneousSpeechInconsistency}
        inconsistencyStatus={inconsistencyStatus}
        setInconsistencyStatus={setInconsistencyStatus}
      />

      <InstabilitiesEvaluation
        selectedInstabilities={selectedInstabilities}
        setSelectedInstabilities={setSelectedInstabilities}
        instabilitiesValues={instabilitiesValues}
        setInstabilitiesValues={setInstabilitiesValues}
      />

      <AdditionalFeaturesEvaluation
        selectedAdditionalFeatures={selectedAdditionalFeatures}
        setSelectedAdditionalFeatures={setSelectedAdditionalFeatures}
        additionalFeaturesValues={additionalFeaturesValues}
        setAdditionalFeaturesValues={setAdditionalFeaturesValues}
      />

      <OverallImpression
        overallImpressionComment={overallImpressionComment}
        setOverallImpressionComment={setOverallImpressionComment}
      />
    </div>
  );
}

export default CAPEVRRatingForm;
